module.exports = "/img/appico.0e6178b5.svg";